module.exports = __webpack_public_path__ + "static/img/russianroulette_th.770aafe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/russianroulette_th.png
// module id = 1tfH
// module chunks = 1